<template>
  <div>
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             @submit.native.prevent
             class="demo-ruleForm">
      <!-- 用户名 -->
      <el-form-item label=""
                    prop="admin">
        <div class="inputtx mt0">
          <el-input prefix-icon="iconfont icon-205yonghu_yonghu6"
                    @focus="inputFocus = 'admin'"
                    placeholder="请输入用户名"
                    @blur="inputFocus = ''"
                    type="text"
                    v-model="ruleForm.admin"
                    autocomplete="off"
                    clearable></el-input>
        </div>
      </el-form-item>
      <!-- 密码 -->
      <el-form-item label=""
                    prop="pwd">
        <div class="inputtx">
          <el-input prefix-icon="iconfont icon-mima"
                    @focus="inputFocus = 'pwd'"
                    placeholder="请输入密码"
                    @blur="inputFocus = ''"
                    :type="inputType ? 'password' : 'text'"
                    v-model="ruleForm.pwd"
                    autocomplete="off">
            <span @click="inputType = !inputType"
                  slot="suffix">
              <i v-if="inputType"
                 style="cursor: pointer; color: #eee"
                 class="iconfont icon-jurassic_openeyes"> </i>
              <i v-else
                 style="cursor: pointer; color: #eee"
                 class="iconfont icon-jurassic_loseeyes"> </i>
            </span>
          </el-input>
        </div>
      </el-form-item>
      <!-- 验证码 -->
      <el-form-item label=""
                    prop="yzm">
        <div class="inputtx">
          <el-input placeholder="请输入验证码"
                    v-model="ruleForm.yzm"
                    autocomplete="off"
                    clearable>
            <template slot="append">
              <img style="height: 40px; display: block; width: 150px; margin-right: 0"
                   :src="imgCodeUrl"
                   @click="updataImgCode" />
            </template>
          </el-input>
        </div>
      </el-form-item>

      <el-form-item class="submit_btn">
        <el-button :loading="isBtnLoading"
                   type="primary"
                   native-type="submit"
                   @click="submitForm('ruleForm')">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import "@/assets/icon/iconfont.css";
export default {
  data () {
    // 手机号验证
    var checkMobile = (rule, value, cb) => {
      const regMobile = /^(0|86|17951)?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/;

      if (regMobile.test(value)) {
        return cb();
      }
      cb(new Error("请输入合法的手机号"));
    };
    var checkPass = (rule, value, cb) => {
      let reg = /^[\u4e00-\u9fa5]{0,}$/;
      if (!reg.test(value)) {
        cb();
      } else {
        cb(new Error("密码不能为特殊字符"));
      }
    };
    return {
      inputType: true,
      imgCodeUrl: "",
      isBtnLoading: false,
      inputFocus: "",
      ruleForm: {
        admin: "",
        pwd: "",
        yzm: "",
      },
      code: "",
      rules: {
        admin: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { validator: checkMobile, trigger: "blur" },
        ],
        pwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 15,
            message: "长度在 6 到 15 个字符",
            trigger: "blur",
          },
          { validator: checkPass, trigger: "blur" },
        ],
        yzm: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        ip:"",//当前的IP地址
      },
    };
  },
  created () {
    this.getLoginImgCode()
      .then((res) => {
        // console.log(res);
        this.imgCodeUrl = res.data.img;
      })
      .catch((err) => {
        console.log(err);
      });
      // let returnCitySN=returnCitySN["cip"]
      // this.ip=returnCitySN
  },
  mounted () {
  },
  methods: {
    ...mapMutations({
      setUserInfo: "setUserInfo", //设置用户信息
      setToken: "setToken", //设置token
      setTokenTime: "setTokenTime", //设置token过期时间
      setLogin: "setLogin", //设置登陆状态
      setRegist: "setRegist", //设置登陆审核状态
      setIsAllinUser: "setIsAllinUser", //设置是否注册通联
    }),
    ...mapActions({
      getLoginImgCode: "loginModule/getLoginImgCode",
      postCheckImg: "loginModule/postCheckImg",
      passwordLogin: "loginModule/passwordLogin",
      getRegisterUrlApi:"loginModule/getRegisterUrlApi",
      BUserInfoLoginPhone:"loginModule/BUserInfoLoginPhone"
    }),
    submitForm (formName) {
      //提交表单
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isBtnLoading = true;
          this.postCheckImg({ codes: this.ruleForm.yzm })
            .then((res) => {
              // console.log(res);
              if (res.data.code === 1) {
                let opt = {
                  cellphones: this.ruleForm.admin,
                  passwd: this.ruleForm.pwd,
                  port: "merchant", //登录端标识，商家后台写死为merchant，系统后台写死为admin
                };
                this.isBtnLoading = false;
                this.passwordLogin(opt)
                  .then((res) => {
                    // console.log(res);
                    if (res.data.code === 1) {
                      if (res.data.reviewer_status == undefined) {
                        res.data.reviewer_status = "1";
                      }
                      switch (res.data.reviewer_status) {
                        case "0":
                          this.$message.warning(res.data.msg);
                          if (res.data.msg == "审核中" || res.data.msg == "审核未通过") {
                            this.$router.push({
                              path: '/regist',
                              query: {
                                phone: this.ruleForm.admin
                              }
                            });
                          }
                          break;
                        case "1":
                          this.$message.success("登录成功");
                          this.setLogin(true);
                          localStorage.setItem("Beitoken",res.data.data.Authorization_token)
                          sessionStorage.setItem("unified_id",res.data.data.user_unified_id)
                          this.setToken(res.data.data.token);
                          this.setIsAllinUser(res.data.data.is_allin_user);
                          this.$setSessionStorage("token", res.data.data.token);
                          this.$setSessionStorage("userid", res.data.data.id);
                          this.$setSessionStorage("merchant_role_id",res.data.data.merchant_role_id);
                          // this.setUserInfo(res.data);
                          this.$router.push("/home");
                          this.LoingBeiJing(this.ruleForm) //执行北京的登录接口
                          break;
                        case "2":
                          if (res.data.msg == "审核中" || res.data.msg == "审核未通过") {
                        this.$router.push({
                              path: '/regist',
                              query: {
                                phone: this.ruleForm.admin
                              }
                            });
                      }
                          break;
                      }
                    } else {
                      this.$message({
                        message: res.data.msg,
                        type: "error",
                      });
                      if (res.data.msg == "审核中" || res.data.msg == "审核未通过") {
                        this.$router.push({
                              path: '/regist',
                              query: {
                                phone: this.ruleForm.admin
                              }
                            });
                      }
                    }
                    this.updataImgCode();
                    this.isBtnLoading = false;
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              } else {
                this.$message({
                  message: "验证码错误",
                  type: "error",
                });
                this.isBtnLoading = false;
              }
            })
            .catch((err) => { });
          // let opt = {
          //   cellphones: this.ruleForm.admin,
          //   passwd: this.ruleForm.pwd,
          //   port: "merchant",//登录端标识，商家后台写死为merchant，系统后台写死为admin
          // };
          // this.loginUser(opt).then((res) => {
          //   console.log(res);
          //   if (res.code == 1) {
          //     this.$message({
          //       message: "登陆成功",
          //       type: "success",
          //     });
          //
          //     this.setLogin(true);
          //     this.setToken(res.data.tokens);
          //     // this.setTokenTime(res.data.userinfo.et);
          //     // this.setUserInfo(res.data);
          //     this.getuserInfo({ tokens: res.data.tokens }).then((ress) => {
          //       console.log("user", ress);
          //       if (ress.code == 1) {
          //         this.setUserInfo(ress.data.list[0]);
          //       }
          //     });
          //     this.$router.push("/home");
          //   } else {
          //     this.$message.error(res.msg);
          //     this.isBtnLoading=false
          //   }
          // });
        } else {
          //校验规则不通过
          return false;
        }
      });
    },
    LoingBeiJing(item){
      // let promas={
      //   ip:returnCitySN["cip"].toString(),
      //   loginName:item.admin,
      //   loginPwd:item.pwd
      // }
      // this.BUserInfoLoginPhone(promas).then(res=>{
      //   console.log('resBeijing :>> ', res);
      //   localStorage.setItem("Beitoken",res.data.data)
      // })
    },
    updataImgCode () {
      this.getLoginImgCode()
        .then((res) => {
          // console.log(res);
          this.imgCodeUrl = res.data.img;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleIconClick () {
      this.inputType = !this.inputType;
    },
  },
};
</script>
<style lang="scss" scoped>
.logo {
  width: 69px;
  height: 69px;
  border-radius: 10px;
  overflow: hidden;
  margin: 16px auto;
  background: #d8d8d8;
}
::v-deep .el-input-group__append {
  padding: 0;
  border: none;
  background: #fff;
}

::v-deep .el-input__inner {
  background: rgba(8, 63, 75, 0.2);
  color: #fff;
  line-height: 40px !important;
  height: 40px !important;
}
::v-deep .el-input {
  background: rgba(8, 63, 75, 0.2);
  line-height: 40px !important;
  height: 40px !important;
}

.mt0.inputtx {
  margin-top: 14px;
}

.inputtx {
  display: flex;
  align-items: center;
  background: transparent;
  border: 1px solid rgba(14, 72, 120);
  border-radius: 6px;
  overflow: hidden;
  margin-top: 28px;
  img {
    width: 16px;
    height: 16px;
    margin-left: 16px;
    cursor: pointer;
  }
}

::v-deep .el-input__inner {
  border: none;
}
::v-deep .el-form-item__error {
  left: 4%;
}
::v-deep .el-form-item {
  margin: 0;
}
.login {
  .login_form {
    width: 26%;
    background: #ffffff;
    // box-shadow: 0px 18px 29px 0px rgba(0, 46, 142, 0.44);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 22%;
    padding: 27px 50px 18px;
    .login_box {
      // height: 260px;
      // padding: 0 50px;
      // background-color: rgba(255, 255, 255, 1);
      // box-shadow: 0px 0px 10px 0px rgba(139, 140, 140, 0.3);
      // border-radius: 2px;
      width: 100%;
      .login_top {
        width: 100%;
        text-align: center;
        height: 20px;
        line-height: 20px;
        margin-bottom: 82px;
        font-size: 24px;
        color: #333333;
        cursor: pointer;
        font-weight: 500;
      }
      .login_bottom {
        .submit_btn {
          margin-top: 32px;
          ::v-deep .el-form-item__content {
            text-align: center;
          }
          ::v-deep .el-button {
            width: 100%;
            font-size: 16px;
            padding: 13px 0;
            border-radius: 6px;
          }
          ::v-deep .el-button--primary {
            background-color: rgba(28, 197, 227);
            border-color: rgba(28, 197, 227);
          }
        }
      }
    }
    .login_img {
      img {
        height: auto;
      }
      img {
        position: absolute;
        top: 0;
        left: 50%;
        z-index: 1;
        width: 10rem;
      }
      .normal {
        transform: translate(-50%, -83%);
      }
      .greeting {
        transform: translate(-50%, -75.8%);
      }
      .blindfold {
        width: 8.6rem;
        transform: translate(-50%, -75%);
      }
    }
  }
}
::v-deep .el-input__suffix {
  right: 10px;
}
::v-deep .el-message-box__btns {
  button {
    width: 80px !important;
  }
}
</style>